import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    success: false,
    ctcCategory: []
};

export const CtcCategoryReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.CTCCATEGORY_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
                ctcCategory: []
            };
        case ActionTypes.CTCCATEGORY_ADD_REQUEST:
        case ActionTypes.CTCCATEGORY_UPDATE_REQUEST:
        case ActionTypes.CTCCATEGORY_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false
            };
        case ActionTypes.CTCCATEGORY_GET_SUCCESS:
        case ActionTypes.CTCCATEGORY_ADD_SUCCESS:
        case ActionTypes.CTCCATEGORY_UPDATE_SUCCESS:
        case ActionTypes.CTCCATEGORY_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                ctcCategory: action.payload?.data?.data
            };
        case ActionTypes.CTCCATEGORY_GET_ERROR:
        case ActionTypes.CTCCATEGORY_ADD_ERROR:
        case ActionTypes.CTCCATEGORY_UPDATE_ERROR:
        case ActionTypes.CTCCATEGORY_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}